import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthComponent } from './auth.component';
import { isUserLoggedInGuard } from '@iris/modules/auth/login/is-user-logged-in.guard';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
        canMatch: [isUserLoggedInGuard],
        pathMatch: 'full',
      },
      {
        path: 'auth/reset',
        canMatch: [isUserLoggedInGuard],
        loadComponent: () => import('./restore-password/restore-password.component').then(m => m.RestorePasswordComponent),
      },
      {
        path: 'sso',
        loadComponent: () => import('./sso/sso.component').then(m => m.SsoLoginComponent),
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
